import modelsToActivities from './models_to_activities'

export default function (models = []) {
  const result = {
    webOnly: false,
    smsOnly: false,
    both: false
  }

  const activities = modelsToActivities(models)
  activities.forEach(activity => {
    const webEnabled = activity.get('web_enabled')
    const smsEnabled = activity.get('sms_enabled')

    if (webEnabled === undefined || smsEnabled === undefined) {
      // Competitions and surveys fall here, with no top-level setting about responses,
      // since their contained activities have their own response settings. To be fully correct,
      // we should recurse into the sub-activities and consider their response settings as well.
      // But, as of this writing, all MQAs are web-only and the team doesn't see a future where
      // SMS voting on MQAs will be supported. If that assumption is ever false, recurse through
      // the contained polls here and account for their response settings. But in the meantime, we
      // save ourselves some network traffic by assuming this is a web-only activity as a whole.
      result.webOnly = true
    } else if (webEnabled && smsEnabled) {
      result.both = true
    } else if (webEnabled) {
      result.webOnly = true
    } else if (smsEnabled) {
      result.smsOnly = true
    }
  })

  return result
}
